import React, { useState, useEffect, useReducer, useRef } from "react";
import { addDestination } from "../../apis/firebase";
import { DestinationType } from "../../constants";
import { addUserDestination, getUser } from "../../state/User";
import { formatDestination } from "../helpers";
import Check from "../utils/icons/Check";

import Close from "../utils/icons/Close";
import { closePopUp, showLoadingPopUp, showPopUp } from "../utils/Overlay";

function GroupingForm({ onSuccess }: { onSuccess: Function }) {
  const [selectedDestinations, toggleDestination] = useReducer(
    (state, destination) => {
      if (state.includes(destination.id)) {
        return state.filter((id) => id !== destination.id);
      } else {
        return [...state, destination.id];
      }
    },
    []
  );
  const [groupName, setGroupName] = useState("");
  const groupNameField = useRef(null);
  const user = getUser();
  const destinations = user?.destinations || [];

  useEffect(() => {
    groupNameField.current.focus();
  }, []);

  return (
    <div className="cf">
      <h3 className="tac">
        Type a name of your group and select two or more destinations
      </h3>
      <div className="mb1">
        <input
          type="text"
          className="block fz08 mt1"
          name="filename"
          placeholder="Group name"
          onChange={(e) => setGroupName(e.target.value)}
          ref={groupNameField}
        />
      </div>
      <div className="mt1 mb1">
        {destinations
          .filter((d) => d.type !== DestinationType.GROUP)
          .map((d) => (
            <button
              key={d.id}
              className={
                "reset as-link block with-icon mb03 fz12 tac " +
                (selectedDestinations.includes(d.id)
                  ? "activated"
                  : "deactivated")
              }
              onClick={() => toggleDestination(d)}
            >
              <small>{formatDestination(d, "text", false)}</small>
            </button>
          ))}
      </div>
      <div className="right">
        <button
          type="button"
          className="reset as-link ib fz1 with-icon"
          onClick={() => {
            closePopUp();
          }}
        >
          <Close size={20} /> Cancel
        </button>
        <button
          type="button"
          className="reset secondary ml1 with-icon"
          onClick={() => onSuccess(user, selectedDestinations, groupName)}
          disabled={selectedDestinations.length < 2 || groupName === ""}
        >
          <Check size={16} /> Create
        </button>
      </div>
    </div>
  );
}

export function groupDestinations() {
  showPopUp(
    <GroupingForm
      onSuccess={async (user, destinations, name) => {
        showLoadingPopUp(<>Creating the destination group...</>);
        const newDestination = await addDestination(
          user,
          DestinationType.GROUP,
          {},
          {
            name,
            destinationIds: destinations,
          }
        );
        addUserDestination(newDestination);
        closePopUp();
      }}
    />,
    {
      width: "450px",
    }
  );
}
